import { ISvgIconProps, SvgIcon } from "./svg-icon.component";


export const ExclamationCircle:React.FC<ISvgIconProps> = (props) => {
    return (
        <SvgIcon size={2.7} {...props} viewBox="0 0 27.083 27.083" ratio={1}>
            <g fill={props.color? props.color: "currentColor"} transform="translate(302.87 -22.287) rotate(180)"><path d="M23.542,10A13.542,13.542,0,1,0,37.083,23.542,13.542,13.542,0,0,0,23.542,10Zm0,25.392a11.85,11.85,0,1,1,11.848-11.85,11.865,11.865,0,0,1-11.848,11.85Zm0-15.236a1.694,1.694,0,0,0-1.694,1.691v8.465a1.693,1.693,0,1,0,3.385,0V21.848a1.69,1.69,0,0,0-1.691-1.691ZM21.848,16.8a1.694,1.694,0,1,1,.5,1.2,1.716,1.716,0,0,1-.5-1.2Z" transform="translate(265.787 -59.37)"/></g>
        </SvgIcon>
    )
}